import { defaultAgent, apiResponse, uploadToGoogle } from '../helpers/web-agent';
import { toastError, toastInfo, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { setOrganizationInfo } from '../helpers/session';
import {
    GET_FARM_ORGANIZATION_REQUEST, GET_FARM_ORGANIZATION, GET_ORGANIZATION, GET_ORGANIZATION_REQUEST,
    GET_ORGANIZATION_CATEGORY_REQUEST, GET_ORGANIZATION_CATEGORY
} from '../constants/action-types';
import { ORGANIZATION_SAVED, ORGANIZATION_DELETED } from '../constants/messages';
import { getLogoRetrieveURL, getLogoUploadURL } from '../constants/utils';
import { FILE_STORAGE_GOOGLE } from '../constants';


export const farmOrganizationRequest = () => ({ type: GET_FARM_ORGANIZATION_REQUEST });

export const farmOrganization = data => ({ type: GET_FARM_ORGANIZATION, payload: data });

export const organizationListRequest = () => ({ type: GET_ORGANIZATION_REQUEST });

export const organizationList = (data) => ({ type: GET_ORGANIZATION, payload: data });

export const organizationCategoryRequest = () => ({ type: GET_ORGANIZATION_CATEGORY_REQUEST });

export const organizationCategory = (data) => ({ type: GET_ORGANIZATION_CATEGORY, payload: data });


export const getFarmOrganization = (farmId, cb) => dispatch => {
    dispatch(farmOrganizationRequest());
    defaultAgent.get(`api/farm/${farmId}/organization`).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb(null);
        } else if (agentResult.data) {
            dispatch(farmOrganization(agentResult.data));

            setOrganizationInfo(agentResult.data);
            if (cb) cb(agentResult.data);
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(null);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb(null);
    });
};


export const getThemes = (cb) => dispatch => {
    defaultAgent.get(`api/organization/theme/list`).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data) {
            if (cb) cb(agentResult.data);
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};


export const getOrganizationList = (haveRequest = true) => dispatch => {
    if (haveRequest) dispatch(organizationListRequest());
    defaultAgent.get('api/organization/list').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(getOrganizationCategory());
            dispatch(organizationList(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const saveOrganization = ({ farm_uuid, ...params }, isConfiguration = true, cb) => dispatch => {
    defaultAgent.put('api/organization/edit', params).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb(false);
        } else if (agentResult.code === ORGANIZATION_SAVED.code) {
            if (isConfiguration) dispatch(getFarmOrganization(farm_uuid));
            dispatch(toastSuccess(ORGANIZATION_SAVED.message));
            if (cb) cb(true);
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(false);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });

}

export const deleteOrganization = (data, cb) => dispatch => {
    defaultAgent.put('/api/organization/delete', { userId: data.userId, organization_uuid: data.organizationUuid })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === ORGANIZATION_DELETED.code) {
                dispatch(getFarmOrganization(data.farm_uuid));
                dispatch(toastInfo(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}


export const uploadLogoFile = (attachment, cb) => {

    const uploadUrl = `${getLogoUploadURL()}logo/`;

    return dispatch => {
        if (attachment.storage === FILE_STORAGE_GOOGLE) {

            uploadToGoogle({ attachment, uploadUrl }).then(res => {
                if (res.status === 200) {
                    const url = `${getLogoRetrieveURL()}logo/${attachment.name}`;
                    if (cb) cb({ url });
                }
                else {
                    dispatch(toastError("Failed to upload"));
                    if (cb) cb({});
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
                if (cb) cb({});
            });
        }
    };
}

export const getOrganizationCategory = (haveRequest = true) => dispatch => {
    if (haveRequest) dispatch(organizationCategoryRequest());
    defaultAgent.get('api/organization/category').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(organizationCategory(agentResult.data));
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}